import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SearchBoxModule } from '../search-box/search-box.module';
import { CheckoutModule } from '../shared/modules/checkout/checkout.module';
import { QuickOrderModule } from '../shared/modules/quick-order/quick-order.module';
import { MainPipeModule } from '../shared/pipes/mainpipe.module';
import { CustomAddToCartComponent } from './custom-add-to-cart/custom-add-to-cart.component';
import { EmptyCartComponent } from './custom-add-to-cart/empty-cart/empty-cart.component';
import { ProductDetailsComponent } from './custom-add-to-cart/product-details/product-details.component';
import { StandardCartComponent } from './custom-add-to-cart/standard-cart/standard-cart.component';
import { EditOrdersComponent } from './edit-orders/edit-orders.component';
import { ImportCartComponent } from './import-cart/import-cart.component';
import { MiniCartComponent } from './mini-cart/mini-cart.component';
import { SavedOrdersComponent } from './saved-orders/saved-orders.component';
import { StandardCartCheckoutComponent } from './standard-cart-checkout/standard-cart-checkout.component';
import { StandardCartConfirmationComponent } from './standard-cart-confirmation/standard-cart-confirmation.component';

@NgModule({
  declarations: [
    CustomAddToCartComponent,
    StandardCartComponent,
    ImportCartComponent,
    EmptyCartComponent,
    ProductDetailsComponent,
    MiniCartComponent,
    SavedOrdersComponent,
    EditOrdersComponent,
    StandardCartCheckoutComponent,
    StandardCartConfirmationComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    NgSelectModule,
    CheckoutModule,
    SearchBoxModule,
    QuickOrderModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SavedCartsComponent: {
          component: SavedOrdersComponent,
        },
        savedOrderDetailsPageComponent: {
          component: EditOrdersComponent,
        },
        PlaceOrderConfirmationComponent: {
          component: StandardCartConfirmationComponent,
        },
      },
    } as CmsConfig),
    MainPipeModule,
  ],
})
export class CustomAddToCartModule {}
